export default "__VITE_ASSET__89ce4822__"